import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { fazerCheckout, forcarCheckoutCheckin, buscarCheckinsComContasEmAberto } from '../../services/api';
import Carregando from '../../components/Carregando/Carregando';

// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./CheckinsAbertos.css";
import '../../styles/global.css';

const CheckinsAbertos = () => {

    const navigate = useNavigate();
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const BASE_URL = JSON.parse(sessionStorage.getItem('BASE_URL'));
    const [checkins, setCheckins] = useState([]);

    const [carregando, setCarregando] = useState(true); 

    const fetchCheckinsComContasEmAberto = async (dadosEnviar) => {
        // setCarregando(true);

        console.log('Entrou em fetchCheckinsComContasEmAberto em ProdutosPage');
        console.log(dadosEnviar);

        try {
            const dados = await buscarCheckinsComContasEmAberto(dadosEnviar);

            console.log('*** checkins: ***', dados.checkins);

            if (dados?.checkins) {
                // vamos setar em checkins, os checkins que vieram
                setCheckins(dados.checkins);
            }
            setCarregando(false);
        } catch (error) {
            console.error('Erro ao buscar produtos:', error);
            setCarregando(false);
        }
        
    }
    
    useEffect(() => {
        console.log('--- ENTROU EM CHECKINS ABERTOS ----');
        // setCarregando(true);
    
        const intervalId = setInterval(() => {
            console.log('Verificando se usuário está logado...');
            
            if (userData) {
                try {
                    if (userData.statusUsuario === 'logado') {
                        console.log('Sim, logado!');
                        const idEstabelecimento = userData.dadosEstabelecimento.id;
                        const dadosEnviar = {
                            idEstabelecimento: idEstabelecimento
                        };
                        console.log('Id do estabelecimento: ');
                        console.log(idEstabelecimento);

                        console.log('Dados enviar: ');
                        console.log(dadosEnviar);

                        console.log('Vamos chamar o fetch... ');

                        // buscar todos os checkins com contas em aberto
                        fetchCheckinsComContasEmAberto(dadosEnviar);

                    } else {
                        console.log('Usuário não está logado, mantendo na área restrita.');
                    }
                } catch (error) {
                    console.error('Erro ao parsear os dados de usuário:', error);
                }
            } else {
                console.log('Usuário NÃO está logado!');
            }
        }, 10000); // 10 segundos
    
        return () => clearInterval(intervalId);
    }, [userData]); // Dependência importante, para garantir que userData esteja atualizado

    const handleGoToForcarCheckoutDoCheckin = async (e, checkin) => {
        e.preventDefault();
        console.log('Entrou em handleGoToForcarCheckoutDoCheckin');
        console.log('Checkin:', checkin);

        try {
            const response = await forcarCheckoutCheckin(checkin);
            console.log('Checkin baixado com sucesso!');
            console.log('Vamos limpar a seção do checkin, gerando o checkout...');

            alert('Checkin baixado com sucesso!');
            navigate('/bar-gerente');
        } catch (error) {
              console.error('Erro ao forçar o checkout:', error);
              // Exibe a mensagem de erro vinda da API
              const errorMessage = error.response?.data?.message || 'Erro ao forçar o checkout. Tente novamente.';
              alert(errorMessage);
        }
    }    

    if (carregando) {
        return <Carregando />;
    }

    return (
        <div className="form-cadastrar-container">
            <TituloComponent />
    
            <form>
                <h2 className="form-title">Checkins Abertos</h2>

                <div className="box-dados">
                    {/* Exibe o nome do perfil do usuário */}
                    <p className="texto-welcome">Você está em { userData.dadosEstabelecimento.nome }!</p>
                </div>

                {/* <h2 className="form-title">Checkins abertos</h2> */}

    
                {checkins.length > 0 &&

                    checkins.map((checkin, index) => {

                        // CALCULAR TOTAL GERAL DO CHECKIN AQUI
                        const totalCheckin = checkin.pedidos.reduce((total, pedido) => {
                            const totalPedido = pedido.produtosDoPedido.reduce((soma, produto) => {
                                const preco = parseFloat(produto.preco_produto * produto.quantidade) || 0;
                                return soma + preco;
                            }, 0);
                            return total + totalPedido;
                        }, 0);

                        return (
                            <div key={index} className="box-dados container-fluid">
                                <div className="row">
                                    <div className="col-md-8">

                                        <p className='nome-cliente-checkin_aberto'>
                                            {checkin.nome_cliente || 'Cliente ainda não se identificou'}
                                        </p>

                                        <p className='numero-mesa-checkin_aberto'>
                                            Mesa {checkin.numero_mesa} - 
                                            Comanda {checkin.numero_comanda}
                                        </p>

                                        {/* LISTA DE PEDIDOS */}
                                        {checkin.pedidos.map((pedido, indexPedido) => {
                                            const totalPedido = pedido.produtosDoPedido.reduce((soma, produto) => {
                                                const preco = parseFloat(produto.preco_produto * produto.quantidade) || 0;
                                                return soma + preco;
                                            }, 0);

                                            return (
                                                <div key={`pedido-${indexPedido}`}>

                                                    <div className="col-md-8">.......</div>

                                                    <p className='numero-pedido-checkin_aberto'>
                                                        Pedido #{pedido.id}
                                                    </p>

                                                    {pedido.produtosDoPedido.map((produto, indexProduto) => (
                                                        <p key={`produto-${indexPedido}-${indexProduto}`} className='nome-produto-checkin_aberto'  >
                                                            {produto.quantidade} X {produto.produtoEstabelecimento.nome} ({produto.id}) - R$ {parseFloat(produto.preco_produto).toFixed(2)} cada
                                                        </p>
                                                    ))}
                                                    {/* <div className="col-md-8">.......</div> */}
                                                    <p className='total-pedido-checkin_aberto'>
                                                        Total do Pedido: R$ {totalPedido.toFixed(2)}
                                                    </p>
                                                    
                                                </div>
                                            );
                                        })}

                                        {/* TOTAL GERAL DO CHECKIN */}
                                        
                                        <div className="col-md-8">.......</div>
                                        <div>
                                        <p className='total-checkin-checkin_aberto'>
                                            Total do Check-in: R$ {totalCheckin.toFixed(2)}                                                
                                        </p>

                                            {/* Botão Meus Produtos */}
                                            <button className="welcome-btn" onClick={(e) => handleGoToForcarCheckoutDoCheckin(e, checkin)} >
                                                Forçar checkout
                                            </button>
                    

                                        </div>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }


            </form>
    
            <div className="mt-4"></div>
        </div>
    );
    
    
};

export default CheckinsAbertos;
